import VwKurumbonustanimDTO from "src/models/KurumBonusTanim/VwKurumbonustanimDTO";
import api from "../core/api";
import VwKurumbonustanimdetayDTO from "src/models/KurumBonusTanim/VwKurumbonustanimdetayDTO";
import VwKurumbonustanimtestveriDTO from "src/models/KurumBonusTanim/VwKurumbonustanimtestveriDTO";

const controllerName = "KurumBonusTanimlari";
const KurumBonusTanimlariApi = api.injectEndpoints({
    endpoints: (builder) => ({
        KurumBonusTanimListesi: builder.query<Array<VwKurumbonustanimDTO>, { aktifGetir: string, iptalGosterme: string }>({
            query: (request) => {
                return {
                    url: `/${controllerName}/KurumBonusTanimListesi`,
                    method: "GET",
                    params: request,
                };
            },
            providesTags: ["KurumBonusTanimlari"],
        }),
        KurumBonusTanimEkle: builder.mutation<VwKurumbonustanimDTO, VwKurumbonustanimDTO>({
            query: (request) => {
                return {
                    url: `/${controllerName}/KurumBonusTanimEkle`,
                    method: "POST",
                    body: JSON.stringify(request),
                };
            },
            invalidatesTags: ["KurumBonusTanimlari"],
        }),
        KurumBonusTanimGuncelle: builder.mutation<VwKurumbonustanimDTO, VwKurumbonustanimDTO>({
            query: (request) => {
                return {
                    url: `/${controllerName}/KurumBonusTanimGuncelle`,
                    method: "PUT",
                    body: JSON.stringify(request),
                };
            },
            invalidatesTags: ["KurumBonusTanimlari"],
        }),
        KurumBonusTanimSil: builder.mutation<VwKurumbonustanimDTO, VwKurumbonustanimDTO>({
            query: (request) => {
                return {
                    url: `/${controllerName}/KurumBonusTanimSil`,
                    method: "DELETE",
                    body: JSON.stringify(request),
                };
            },
            invalidatesTags: ["KurumBonusTanimlari"],
        }),
        //
        KurumBonusTanimDetayListesi: builder.query<Array<VwKurumbonustanimdetayDTO>, { kurumBonusTanimId: number, iptalGosterme: string }>({
            query: (request) => {
                return {
                    url: `/${controllerName}/KurumBonusTanimDetayListesi`,
                    method: "GET",
                    params: request,
                };
            },
            providesTags: ["KurumBonusTanimlariDetay"],
        }),
        KurumBonusTanimDetayEkle: builder.mutation<VwKurumbonustanimdetayDTO, VwKurumbonustanimdetayDTO>({
            query: (request) => {
                return {
                    url: `/${controllerName}/KurumBonusTanimDetayEkle`,
                    method: "POST",
                    body: JSON.stringify(request),
                };
            },
            invalidatesTags: ["KurumBonusTanimlariDetay"],
        }),
        KurumBonusTanimDetayGuncelle: builder.mutation<VwKurumbonustanimdetayDTO, VwKurumbonustanimdetayDTO>({
            query: (request) => {
                return {
                    url: `/${controllerName}/KurumBonusTanimDetayGuncelle`,
                    method: "PUT",
                    body: JSON.stringify(request),
                };
            },
            invalidatesTags: ["KurumBonusTanimlariDetay"],
        }),
        KurumBonusTanimDetaySil: builder.mutation<VwKurumbonustanimdetayDTO, VwKurumbonustanimdetayDTO>({
            query: (request) => {
                return {
                    url: `/${controllerName}/KurumBonusTanimDetaySil`,
                    method: "DELETE",
                    body: JSON.stringify(request),
                };
            },
            invalidatesTags: ["KurumBonusTanimlariDetay"],
        }),

        KurumBonusTanimTestVeriListesi: builder.query<Array<VwKurumbonustanimtestveriDTO>, { kurumBonusTanimDetayId: number, iptalGosterme: string }>({
            query: (request) => {
                return {
                    url: `/${controllerName}/KurumBonusTanimTestVeriListesi`,
                    method: "GET",
                    params: request,
                };
            },
            providesTags: ["KurumBonusTanimlariDetayTestVeri"],
        }),
        KurumBonusTanimTestVeriEkle: builder.mutation<VwKurumbonustanimtestveriDTO, VwKurumbonustanimtestveriDTO>({
            query: (request) => {
                return {
                    url: `/${controllerName}/KurumBonusTanimTestVeriEkle`,
                    method: "POST",
                    body: JSON.stringify(request),
                };
            },
            invalidatesTags: ["KurumBonusTanimlariDetayTestVeri"],
        }),
        KurumBonusTanimTestVeriGuncelle: builder.mutation<VwKurumbonustanimtestveriDTO, VwKurumbonustanimtestveriDTO>({
            query: (request) => {
                return {
                    url: `/${controllerName}/KurumBonusTanimTestVeriGuncelle`,
                    method: "PUT",
                    body: JSON.stringify(request),
                };
            },
            invalidatesTags: ["KurumBonusTanimlariDetayTestVeri"],
        }),
        KurumBonusTanimTestVeriSil: builder.mutation<VwKurumbonustanimtestveriDTO, VwKurumbonustanimtestveriDTO>({
            query: (request) => {
                return {
                    url: `/${controllerName}/KurumBonusTanimTestVeriSil`,
                    method: "DELETE",
                    body: JSON.stringify(request),
                };
            },
            invalidatesTags: ["KurumBonusTanimlariDetayTestVeri"],
        }),
    }),
});

export const {
    useKurumBonusTanimListesiQuery,
    useKurumBonusTanimEkleMutation,
    useKurumBonusTanimGuncelleMutation,
    useKurumBonusTanimSilMutation,

    useKurumBonusTanimDetayListesiQuery,
    useKurumBonusTanimDetayEkleMutation,
    useKurumBonusTanimDetayGuncelleMutation,
    useKurumBonusTanimDetaySilMutation,

    useKurumBonusTanimTestVeriListesiQuery,
    useKurumBonusTanimTestVeriEkleMutation,
    useKurumBonusTanimTestVeriGuncelleMutation,
    useKurumBonusTanimTestVeriSilMutation,
} = KurumBonusTanimlariApi;